import type { LeadStatus } from '@flashpoint/site-dna';

/** One accent per stage, used for badges, edge bands, pills, and the funnel. */
export const STATUS_META: Record<LeadStatus, { color: string; bg: string; hint: string }> = {
  Discovery: {
    color: 'var(--nm-info)',
    bg: 'var(--nm-info-bg)',
    hint: 'On the call',
  },
  'Demo Generated': {
    color: 'var(--nm-warn)',
    bg: 'var(--nm-warn-bg)',
    hint: 'Preview live',
  },
  'In Pipeline': {
    color: 'var(--nm-success)',
    bg: 'var(--nm-success-bg)',
    hint: 'Locked live',
  },
};
